import { autoinject, observable } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { DemoDataService } from 'app/demo/services/demo-data-service';
import { guid } from 'app/shared/lib/guid';

@autoinject()
export class DemoEssSelectPage extends ComponentBase {

    protected autocompleteOptions: Array<string> = ['off', 'on'];
    protected iconOptions: Array<string> = ['ui:icons.dollar', 'ui:icons.add', 'ui:icons.phone'];
    protected numbersOptions: Array<string> = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
    protected id: guid = guid();

    ////****************** Lifecycle events (in order of execution) *****************////

    constructor(
        private readonly service: DemoDataService,
        ...rest: any[]) {
        super(...rest);
    }

    protected bind(): void {
        this.loadData();
    }
    ////****************** Example 1 ********************************************////

    ////****************** Example 2 ********************************************////
    protected ex2Select: Array<string> = []
    protected ex2MaxDisplay: number | null = 5;

    ////****************** Example 3 ********************************************////
    protected ex3Select: string | Array<string> = [];
    protected ex3Label: string | null = 'Enter a Value';
    protected ex3AriaLabelValue: string | null = 'Select All';
    protected ex3OverrideAriaLabel: string | null = 'Aria LabeledBy Override';
    protected ex3RequiredValidatorLabel: string | null = 'Enter a value';
    protected ex3Placeholder: string | null = 'Select All'
    protected ex3MaxDisplay: number = 10;
    protected ex3Options: Array<string> = [];
    protected newOption: string | null = '';

    protected ex3Multiple: boolean = true;
    protected ex3AllowSelectAll: boolean = true;

    protected addToDropdown(): void {
        if(this.newOption) {
            this.ex3Options.push(this.newOption);
        }
    }

    protected clearDropdown(): void {
        this.ex3Options = []
    }

    protected removeFromDropdown(item: any): void {
        const { option } = item;
        if(option) {
            this.ex3Options.splice(this.ex3Options.indexOf(option), 1);
        }
    }

    protected async loadData(): Promise<void> {
        await this.doLoad(async () => {
            const response = await this.service.loadData('example-states');
            this.ex3Options = response.results.map(value => value.$display);
        });
    }
}
